import { useTranslation } from 'react-i18next';
import CategoryRadarSection from './shared/CategoryRadarSection';
import type { SelfDeterminationStatistic } from './shared/utils';

interface SelfDeterminationResultProps {
    statistics: SelfDeterminationStatistic;
    summaryFormation?: number[];
}

const SelfDeterminationResult = ({ statistics, summaryFormation = [2, 2] }: SelfDeterminationResultProps) => {
    const { t } = useTranslation('assessmentResultManagementPage');

    return (
        <CategoryRadarSection
            statistics={{
                domainMax: statistics.domainMax,
                radarData: statistics.radarData,
                summaryCards: statistics.summaryCards,
                tickCount: Math.min(11, statistics.domainMax + 1),
            }}
            summaryFormation={summaryFormation}
            summaryValueDecimals={2}
            tooltipValueLabel={t('details.selfDetermination.yourScore')}
            tooltipAxisLabel={t('details.selfDetermination.category')}
        />
    );
};

export default SelfDeterminationResult;
